import JwtDecode from 'jwt-decode';
import React, { useEffect, useState } from 'react';

import { getUser } from '../../core/api/user';
import { addAuthInterceptor, removeAuthInterceptor } from '../../core/config/httpClient';
import { AuthContext, AuthProviderProps } from './AuthContext';
import { User } from './authContext.types';

const E2eAuthProvider: React.FC<AuthProviderProps> = ({ children }) => {
  const [user, setUser] = useState<User>();
  const [isLoading, setLoading] = useState(true);

  useEffect(() => {
    setLoading(false);
  }, []);

  const login = async () => {
    const e2eAccessToken: string | null = window.localStorage.getItem('e2eAccessToken');
    if (e2eAccessToken) {
      addAuthInterceptor({
        accessToken: e2eAccessToken,
        tokenRefresh: () => Promise.resolve(),
      });

      const userFFDB = await getUser(e2eAccessToken);
      const user = JwtDecode(e2eAccessToken) as any;
      user.canAccess = userFFDB.data.canAccess;
      user.fullName = userFFDB.data.fullName;
      user.searchResultLimit = userFFDB.data.searchResultLimit;
      user.isTrialUser = userFFDB.data.isTrialUser;
      user.isAdminUser = userFFDB.data.isAdminUser;
      user.accessRoles = userFFDB.data.accessRoles;
      user.pillarsAccess = userFFDB.data.pillarsAccess;
      user.hasCustomReport = userFFDB.data.hasCustomReport;

      setUser(user);
      setLoading(false);
    } else {
      setLoading(true);
    }
  };

  const logout = async () => {
    localStorage.clear();
    removeAuthInterceptor();
  };

  const clearSessions = async () => {};

  return (
    <AuthContext.Provider
      value={{
        user,
        userId: user?.sub,
        isLoading,
        login,
        logout,
        clearSessions,
        canLogin: true,
      }}
    >
      {children}
    </AuthContext.Provider>
  );
};

export default E2eAuthProvider;
